export function jwtDecode(jwt: string) {
    if (!jwt) return undefined;
    var parts = jwt.split(".");
    if (parts.length < 2) return undefined;
    return JSON.parse(url_base64_decode(parts[1]));

}


function url_base64_decode(str) {
    var output = str.replace(/-/g, '+').replace(/_/g, '/');
    switch (output.length % 4) {
        case 0:
            break;
        case 2:
            output += '==';
            break;
        case 3:
            output += '=';
            break;
        default:
            throw 'Illegal base64url string!';
    }
    var result = window.atob(output); //polifyll https://github.com/davidchambers/Base64.js
    try {
        return decodeURIComponent(escape(result));
    } catch (err) {
        return result;
    }
}